import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AdminProvider } from "./contexts/AdminContext";
import MetaTags from "./components/MetaTags";

function App() {
  return (
    <AdminProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <MetaTags />
        <AppRoutes />
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
